import { AbacoWebModule, RouterReadyEvent, VueRouter, MenuItem, ApplicationReadyEvent } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import FarmMapVuexModule from './state';
import { createMenu } from './menu';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import SSOModule, { MODULE_ID as SSO_MODULE_ID } from "@abaco/sso-web-module/src/abaco-module/index"
import SsoVuexModule from '@abaco/sso-web-module/src/abaco-module/state';
import MapModule, { MODULE_ID as MAP_MODULE_ID } from '@abaco/map-web-module/src/modules/map-web-module';
import FarmerRegistryModule, { MODULE_ID as FARM_REGISTRY_MODULE_ID } from '@abaco/farm-registry/src/modules/farm-registry';
import GlobalStateModule, { MODULE_ID as GLOBAL_STATE_ID } from '@abaco/portal-global-state/src/modules/global-state';
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard/index";
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts/index";
import WeatherApi from './api/WeatherApi';

export const MODULE_ID = "farm_map_module";

export interface FarmMapModuleOptions {
    hasExtraGlobals?: boolean;
    environment?: string;
}

const state = new FarmMapVuexModule();

export default class FarmMapModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;
    public readonly hasExtraGlobals!: boolean;
    public readonly environment!: string | null;

    private router!: VueRouter;
    private http!: HTTPClient;
    private ssoStore!: SsoVuexModule;
    private wthApi!: WeatherApi;

    private apiCreated = false;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = state;
    menu: MenuItem[] = [];

    constructor(options?: FarmMapModuleOptions){
        this.hasExtraGlobals = options?.hasExtraGlobals || false;
        this.environment = options?.environment || null;
    }

    dependsOn = {
        [MAP_MODULE_ID]: () => new MapModule(),
        [FARM_REGISTRY_MODULE_ID]: () => new FarmerRegistryModule(),
        [GLOBAL_STATE_ID]: () => new GlobalStateModule(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule({ hasEstraGlobals: this.hasExtraGlobals }),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule()
    }

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.http = evt.http;
        this.menu = createMenu(this.router);
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        const ssoModule = evt.modules.find((m) => m.id === SSO_MODULE_ID) as SSOModule | undefined;
        if (!ssoModule) {
            throw new Error("SSOModule not found!");
        }
        this.ssoStore = ssoModule.vuexModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;
        const WeatherApi = (await import("./api/WeatherApi")).default;
        this.wthApi = new WeatherApi(http, this.ssoStore, this.environment);
    }

    public get weatherApi(){
        return this.wthApi;
    }

}
